import { render, staticRenderFns } from "./success-dialog.vue?vue&type=template&id=b6c89816&scoped=true"
import script from "./success-dialog.vue?vue&type=script&lang=js"
export * from "./success-dialog.vue?vue&type=script&lang=js"
import style0 from "./success-dialog.vue?vue&type=style&index=0&id=b6c89816&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c89816",
  null
  
)

export default component.exports